const FIELD_TYPE = {
  ASFALT: { label: 'Asfalt', value: 0 },
  TERACO: { label: 'Teraco', value: 1 },
  BETONSKAPOVRSINA: { label: 'Betonska površina', value: 2 },
  ZELENAPOVRSINA: { label: 'Zelena površina', value: 3 },
  UOBJEKTU: { label: 'U objektu', value: 4 },
  PRIVATNIPOSJED: { label: 'Privatni posjed', value: 5 },
  NEPOZNATO: { label: 'Nepoznato', value: 6 },
};

export default FIELD_TYPE;
